import BookingCard from "./BookingCard";
export default BookingCard;
